export default "__VITE_ASSET__DjdGnY$5__"